var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRendered())?_c('a',{staticClass:"dropdown-item",attrs:{"title":_vm.title},on:{"click":_vm.action}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }